export { default as Logo } from '../../components/Logo.vue'
export { default as VuetifyLogo } from '../../components/VuetifyLogo.vue'
export { default as Core } from '../../components/core/404.vue'
export { default as CoreAppBar } from '../../components/core/AppBar.vue'
export { default as CoreDrawer } from '../../components/core/Drawer.vue'
export { default as CoreFilter } from '../../components/core/Filter.vue'
export { default as CoreFooter } from '../../components/core/Footer.vue'
export { default as CoreFooterAuth } from '../../components/core/FooterAuth.vue'
export { default as CoreView } from '../../components/core/View.vue'
export { default as HelperCurrencyInput } from '../../components/helper/CurrencyInput.vue'
export { default as HelperEditor } from '../../components/helper/Editor.vue'
export { default as HelperJenjangJurusanFilter } from '../../components/helper/JenjangJurusanFilter.vue'
export { default as HelperJenjangSelect } from '../../components/helper/JenjangSelect.vue'
export { default as HelperJurusanInput } from '../../components/helper/JurusanInput.vue'
export { default as HelperOffset } from '../../components/helper/Offset.vue'
export { default as MaterialCard } from '../../components/material/Card.vue'
export { default as MaterialCardTable } from '../../components/material/CardTable.vue'
export { default as MaterialChartCard } from '../../components/material/ChartCard.vue'
export { default as MaterialNotification } from '../../components/material/Notification.vue'
export { default as MaterialStatsCard } from '../../components/material/StatsCard.vue'
export { default as ModalPreviewFile } from '../../components/modal/PreviewFile.vue'
export { default as CoreGuestAppBar } from '../../components/core/guest/AppBar.vue'
export { default as CoreGuestCarousel } from '../../components/core/guest/Carousel.vue'
export { default as CoreGuestFooter } from '../../components/core/guest/Footer.vue'
export { default as CoreGuestView } from '../../components/core/guest/View.vue'

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
